import mitt from "mitt";

type GifPlaybackEvent = {
  id: string;
  duration: number;
};

type MainBusEvents = {
  gif_view: string;
  gif_playback: GifPlaybackEvent;
  toggle_fullscreen: { id?: string } | undefined;
  close_search: void;
};

export const bus = mitt<MainBusEvents>();
